import screenReaderButtonClick from '@hh.ru/analytics-js-events/build/xhh/common/a11y/screen_reader_button_click';
import screenReaderButtonFocus from '@hh.ru/analytics-js-events/build/xhh/common/a11y/screen_reader_button_focus';

import Components from 'HHC/Components';
import { CONTENT_ID, INPUT_ID } from 'src/components/A11y/A11yConstants';

interface Params {
    trls: {
        goToInput: string;
        goToMainContent: string;
    };
}

const createLink = (
    target: HTMLElement,
    id: string,
    text: string,
    index: number,
    preventDefault: boolean,
    hasFocusEvent: boolean
) => {
    const anchore = document.createElement('a');
    anchore.setAttribute('href', `#${id}`);
    anchore.setAttribute('data-qa', id);
    anchore.setAttribute('tabindex', `${index}`);
    anchore.innerText = text;

    if (hasFocusEvent) {
        anchore.addEventListener('focus', () => {
            screenReaderButtonFocus();
        });
    }

    anchore.addEventListener('click', (event) => {
        if (preventDefault) {
            event.preventDefault();
        }
        target.focus();
        screenReaderButtonClick({ name: id });
    });
    return anchore;
};

const A11YLink = (element: HTMLElement, params: Params) => {
    const elementsConfig = {
        [INPUT_ID]: {
            text: params.trls.goToInput,
            preventDefault: true,
            tabindex: 1,
        },
        [CONTENT_ID]: {
            text: params.trls.goToMainContent,
            preventDefault: false,
            tabindex: 2,
        },
    };

    let linksCounter = 0;
    Object.keys(elementsConfig).forEach((id) => {
        const nodes = document.querySelectorAll<HTMLElement>(`#${id}`);
        const visibleNodes = [...nodes].filter((node) => node.offsetParent);
        if (visibleNodes.length) {
            if (visibleNodes.length > 1) {
                console.error('Element must have uniq ID!');
            } else {
                element.appendChild(
                    createLink(
                        visibleNodes[0],
                        id,
                        elementsConfig[id].text,
                        elementsConfig[id].tabindex,
                        elementsConfig[id].preventDefault,
                        linksCounter === 0
                    )
                );
                linksCounter += 1;
            }
        }
    });
};

export default Components.build({
    create: A11YLink,
});
